import { APIData, initialValue,  STATE } from '../../constants';
import axios from '@lib/service';
import { useEffect, useState, Dispatch, SetStateAction } from 'react';


function useRest(endpoint: string, options?: APIData): [APIData, Dispatch<SetStateAction<APIData>>] {
  const [res, setRes] = useState<APIData>({ ...initialValue, ...options });

  useEffect(() => {
    if (res.state === STATE.READY) {
      setRes({ ...res, state: STATE.LOADING });
      // Create query (string) params
      const query = (res?.query ? `?${new URLSearchParams(res.query as string)}` : '');
      axios({
        data: { data: res.data },
        method: res.operation,
        // Concat query string with endpoint url
        url: endpoint.concat(query),
      })
        .then(function (response) {
          // handle success
          // const { data, message } = response;
          setRes({ ...res, ...response, state: STATE.DONE });
        })
        .catch(function (error) {
          // handle error
          const message = error?.response?.data?.message || error.message;
          setRes({ ...res, message: message, state: STATE.ERROR });
        });
    }
  }, [res]);

  return [res, setRes];
}

export default useRest;
